/**
 * Created by mingyue on 17/1/3.
 */
import decode from 'jwt-decode'

const setToken = (token) => {

	window.localStorage.setItem('token', token);

}
const getToken = () => {
	return window.localStorage.getItem('token');
}


const decodeToken = () => {
	if(getToken()) {
		return decode(getToken())
	}
}

const getUserInfo = () => {
	
	var _tk = null;
	if(_tk = getToken()) {
		
		let userinfo = decode(_tk);
		if(userinfo) {
			return userinfo
		} else {
			return false;
		}

	} else {
		return false
	}
}

export default {
	setToken,
	getToken,
	decodeToken,
	getUserInfo
	
}